module.exports = __webpack_public_path__ + "static/img/008.f68eed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-yongdong/008.png
// module id = c8p+
// module chunks = 1